import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSesion } from '../contexto/Sesion.js';
import { ErrorApi } from '../api/cliente.js';

export function LoginOperador() {
  const { loginOperador } = useSesion();
  const navegar = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);

  async function enviar(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setCargando(true);
    try {
      await loginOperador(email, password);
      navegar('/operador');
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : 'No se pudo iniciar sesión');
    } finally {
      setCargando(false);
    }
  }

  return (
    <div className="web" style={{ maxWidth: 420, paddingTop: 64 }}>
      <div style={{ textAlign: 'center', marginBottom: 20 }}>
        <h1 style={{ color: 'var(--verde)' }}>Ausentia</h1>
        <p className="mini" style={{ margin: '-8px 0 8px' }}>by AtuelSoft</p>
        <p className="muted">Panel del operador · Facturación</p>
      </div>
      <form onSubmit={enviar} className="tarjeta" style={{ padding: 20 }}>
        <div className="campo">
          <label htmlFor="ope-email">Email</label>
          <input id="ope-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="campo">
          <label htmlFor="ope-pass">Contraseña</label>
          <input id="ope-pass" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {error && <div className="error-box">{error}</div>}
        <button className="primario" disabled={cargando}>{cargando ? 'Ingresando…' : 'Ingresar'}</button>
      </form>
      <p style={{ textAlign: 'center', marginTop: 14 }}><Link to="/">← Volver al inicio</Link></p>
    </div>
  );
}
